import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { ChevronDoubleDownIcon, ChevronDoubleRightIcon } from '@heroicons/react/20/solid';

interface SidebarSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  defaultOpen?: boolean;
  growWithContent?: boolean;
  lockedOverlay?: React.ReactNode;
  expandSignal?: number;
  headerBadge?: string | number;
  prefixIcon?: React.ReactNode;
}

export function SidebarSection({
  title,
  children,
  className,
  defaultOpen = false,
  growWithContent = false,
  lockedOverlay,
  expandSignal,
  headerBadge,
  prefixIcon,
}: SidebarSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  useEffect(() => {
    if (expandSignal !== undefined && expandSignal > 0) {
      setOpen(true);
    }
  }, [expandSignal]);
  return (
    <section className={clsx('flex flex-col flex-shrink-0 border-b border-gray-100 min-w-0', className)}>
      <button
        type="button"
        onClick={() => setOpen(prev => !prev)}
        className="flex items-center gap-2 w-full min-w-0 px-4 py-2.5 text-xs font-semibold text-gray-500 uppercase tracking-wider bg-gray-50/80 hover:bg-gray-100 flex-shrink-0 text-left"
        aria-expanded={open}
      >
        {prefixIcon}
        <span className="truncate">{title}</span>
        {headerBadge !== undefined && (
          <span
            className="inline-flex w-auto items-center justify-center rounded-sm px-1.5 font-normal py-0.5 normal-case tracking-normal"
            style={{
              color: '#be0080',
              border: '1px solid rgba(236, 42, 153, 0.45)',
              backgroundColor: 'rgba(236, 42, 153, 0.08)',
              fontSize: '10px',
            }}
          >
            {headerBadge}
          </span>
        )}
        {open ? (
          <ChevronDoubleDownIcon className="ml-auto h-4 w-4 flex-shrink-0" style={{ color: '#94A3B8' }} />
        ) : (
          <ChevronDoubleRightIcon className="ml-auto h-4 w-4 flex-shrink-0" style={{ color: '#94A3B8' }} />
        )}
      </button>
      {open && (
        <div
          className={clsx(
            'relative min-w-0 px-1 flex flex-col',
            growWithContent ? 'flex-none overflow-visible' : 'flex-1 min-h-0 overflow-hidden',
          )}
        >
          {children}
          {lockedOverlay && (
            <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 locked-overlay">
              {lockedOverlay}
            </div>
          )}
        </div>
      )}
    </section>
  );
}
